;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { CanaryClient } from '@qogita/deprecated-canary-client'
import { queryOptions } from '@tanstack/react-query'
import { getPrivateQueryKey } from 'src/deprecated/utils/queryKey'

export function getStocklistSourceStatusQueries(canaryClient: CanaryClient) {
  const queries = {
    all: () => [...getPrivateQueryKey(), 'stocklist-source'] as const,
    status: () =>
      queryOptions({
        queryKey: [...queries.all()],
        queryFn: () => canaryClient.getStocklistSourceStatus(),
      }),
  }

  return queries
}
